export default __webpack_public_path__ + "static/media/mamut_s3.c87ffa44.png";